import moment from 'moment';

const isValidElectionDate = (value) => {
  if (!value) {
    return false;
  }

  const parsed = moment.utc(value);
  return parsed.isValid() && parsed.year() > 1;
};

export const isElectionDateWindowActive = ({
  startActiveAt,
  endActiveAt,
  now = moment.utc(),
}) => {
  if (!isValidElectionDate(startActiveAt) || !isValidElectionDate(endActiveAt)) {
    return false;
  }

  const currentDate = moment.utc(now).startOf('day');
  const startDate = moment.utc(startActiveAt).startOf('day');
  const endDate = moment.utc(endActiveAt).endOf('day');

  return currentDate.isSameOrAfter(startDate) && currentDate.isSameOrBefore(endDate);
};

export const isElectionActive = ({
  locked,
  activeStatus,
}) => Boolean(locked || activeStatus);

export const isElectionStatusToggleDisabled = ({
  locked,
  activeStatus,
  startActiveAt,
  endActiveAt,
  now = moment.utc(),
}) =>
  isElectionActive({ locked, activeStatus })
  && isElectionDateWindowActive({ startActiveAt, endActiveAt, now });
